import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const restoreDealerOrdersManagement = () => ({
  'type': ActionTypes.RESTORE_DEALER_ORDERS_MANAGEMENT,
});

export const editDealerOrdersManagementFilter = (field, value) => ({
  'type': ActionTypes.EDIT_DEALER_ORDERS_MANAGEMENT_FILTER,
  'payload': {field, value},
});

export const getDealersOrdersList = (filters = {}) => apiActionCreator({
  'endpoint': `/orders/dealers/administration${getUrlParameters(filters)}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_DEALER_ORDERS_LIST_REQUEST,
    [
      ActionTypes.GET_DEALER_ORDERS_LIST_SUCCESS,
    ],
    [
      ActionTypes.GET_DEALER_ORDERS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const saveDealerOrderComment = (orderSequence, comment) => apiActionCreator({
  'endpoint': '/orders/dealers/comments',
  'authenticated': true,
  'types': [
    ActionTypes.SAVE_DEALER_ORDER_COMMENT_REQUEST,
    {
      'type': ActionTypes.SAVE_DEALER_ORDER_COMMENT_SUCCESS,
      'payload': {orderSequence, comment},
    },
    [
      ActionTypes.SAVE_DEALER_ORDER_COMMENT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': {orderSequence, comment},
});
